import Vue from 'vue'
import Router from 'vue-router'
import VuePaginate from 'vue-paginate'
import RouteParent from '@/components/RouteParent'
import RouteChildren from '@/components/RouteChildren'
import RouteBreadCrumb from '@/components/RouteBreadCrumb'

Vue.use(Router)
Vue.use(VuePaginate)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/home/'
    },
    {
      path: '/home/',
      components: {
        default: RouteParent,
        child: RouteChildren,
        breadCrumb: RouteBreadCrumb
      }
    },
    {
      path: '/home/:slug',
      name: 'Home',
      components: {
        default: RouteParent,
        child: RouteChildren,
        breadCrumb: RouteBreadCrumb
      }
    },
    {
      path: '/business/',
      components: {
        default: RouteParent,
        child: RouteChildren,
        breadCrumb: RouteBreadCrumb
      }
    },
    {
      path: '/business/:slug',
      name: 'Business',
      components: {
        default: RouteParent,
        child: RouteChildren,
        breadCrumb: RouteBreadCrumb
      }
    },
    {
      path: '/gift/',
      components: {
        default: RouteParent,
        child: RouteChildren,
        breadCrumb: RouteBreadCrumb
      }
    },
    {
      path: '/gift/:slug',
      name: 'Gift',
      components: {
        default: RouteParent,
        child: RouteChildren,
        breadCrumb: RouteBreadCrumb
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js